import { FC, useMemo } from 'react';
import { Entity, ProtectedEntityType } from '../../../../api';
import { ENTITY_TYPE_TO_ICON } from './consts';
import { Icons, ListItem } from '@silverfort/sf-components';
import { bigNumberToText } from '../../../utils';
import { useGetEntityUsersChildrenCount } from '../../api';

interface Props {
    entity: Entity;
    displayedField: string;
    onRemove: (entity?: Entity) => void;
}

const SelectedEntityItem: FC<Props> = ({ entity, displayedField, onRemove }) => {
    const { count, loading } = useGetEntityUsersChildrenCount({
        entityGuid: entity.guid,
        enabled: entity.type !== ProtectedEntityType.USER
    });

    const badgeProps = useMemo(() => {
        if (count !== undefined) {
            return {
                text: bigNumberToText(count)
            };
        }

        return undefined;
    }, [count]);

    return (
        <ListItem
            value={entity}
            IconLeft={ENTITY_TYPE_TO_ICON[entity.type] ?? Icons.Add}
            subtitle={`(${entity.domainName})`}
            title={entity[displayedField]}
            badgeProps={badgeProps}
            badgeLoading={loading}
            onRemove={onRemove}
        />
    );
};

export default SelectedEntityItem;
